import React, { useState, useRef, useEffect } from "react";
import moment from "moment";
import Select from "react-select";
import * as Yup from "yup";
import useAxios from "hooks/useAxios";
import { Field, Formik } from "formik";
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { cloneDeep, find } from "lodash";
import { default as ReactSelect } from "react-select";
import { Option, LimitedChipsContainer } from "components/Options";
import ErrorBoundary from "components/ErrorBoundary";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikInputField from "components/common/Fields/FormikInputField";
import Calendar from "assets/icon/calendar-icon.svg";
import {
  pharmcyOptions,
  coveredEntityOptions,
  thirdPartyOptions,
} from "pages/commonData";
import CoveredEntityList from "components/CoveredEntityList";
import CoveredEntity from "components/CoveredEntity";
import reset from "assets/icon/reset.svg";
import searchicon from "assets/icon/search.svg";

const validationSchema = Yup.object({
  coveredEntityID: Yup.string().required("Covered Entity is required"),
});

const SearchFormulary = ({
  handleUpdateEntity,
  onSearch,
  onReset,
  initialValue,
}) => {
  const API = useAxios();
  const formikRef = useRef();
  const [isSubmitting, setSubmitting] = useState(true);
  const [searchCEterm, setSearchCEterm] = useState("");
  const [selectedCE, setSelectedCE] = useState(null);
  const [entityName, setEntityName] = useState("");
  const [ceList, setCEList] = useState([]);
  const [ceLoading, setCeLoading] = useState(false);
  const [showError, setError] = useState(false);

  const handleSubmit = async (val, actions) => {
    val.coveredEntityName = selectedCE.id;
    const values = cloneDeep(val);

    await onSearch(values);
    setSubmitting(false);
  };

  const findCE = async (value) => {
    setSearchCEterm(value);
  };
  useEffect(() => {
    fetchCeList();
  }, []);
  const fetchCeList = async () => {
    try {
      const { data } = await API.get(`GWConfig/coveredentity/CElist`, {
        hasDefaultURL: true,
        hideLoader: true,
      });
      setCEList(data);
      setSearchCEterm("");
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleCoverdEntityChange = async (entity) => {
    if (!entity) {
      setSelectedCE("");
      return setError(true);
    }
    handleUpdateEntity(entity);
    setSelectedCE(entity);
    setError(false);
  };
  const handleReset = (props) => {
    setSelectedCE(null);
    const { resetForm } = props;
    setError(false);
    resetForm();
    onReset();
  };

  const onSelectCE = (entity, setFieldValue) => {
    if (entity) {
      setFieldValue("coveredEntityID", entity.id);
      setSelectedCE(entity);
      handleUpdateEntity(entity);
    } else {
      setFieldValue("coveredEntityID", '');
      setSelectedCE(null);
    }
  };

  return (
    <Formik
      innerRef={formikRef}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize={true}
      initialValues={initialValue}
      children={(props) => {
        const {
          isSubmitting,
          setFieldValue,
          handleSubmit,
          resetForm,
          errors,
          touched,
        } = props;
        return (
          <div>
            <h5 className="f-16 text-primary font-weight-700">Search Formulary</h5>
            <Row>
              <Col md={3} sm={3} xs={3}>
                <FormGroup className="config">
                  <Label for="coveredEntity">Covered Entity</Label>
                  {/* <CoveredEntity
                  thirdPartyAdminID={0}
                  onSelect={(value)=>onSelectCE(value,setFieldValue)}
                  selectedCE={selectedCE}
                  /> */}
                  <Select
                    id="coveredEntityID"
                    className="form-field-large inner-shadow-field required" //npi-name
                    classNamePrefix="select"
                    IndicatorSeparator
                    isSearchable={true}
                    isLoading={ceLoading}
                    placeholder="Enter OPAID Or CE Name"
                    isClearable={true}
                    name="color"
                    options={ceList}
                    value={selectedCE}
                    inputValue={searchCEterm}
                    onInputChange={findCE}
                    onChange={(value) => onSelectCE(value, setFieldValue)}
                    getOptionLabel={(option) => option.description}
                    getOptionValue={(option) => option.id}
                    // isDisabled={!tenantID}
                    components={{
                      // DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                    }}
                  />
                  {errors.coveredEntityID && touched.coveredEntityName ? (
                    <div className="text-danger f-10 position-absolute">
                      {errors.coveredEntityID}
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
            </Row>
            <Row className="d-flex justify-content-end">
              <Col md="auto" className="pt-4 mt-1">
                <Label>{""}</Label>
                <Button
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  color="primary"
                  className="search ms-3"
                >
                  <span className="right_5">
                    <img src={searchicon} alt="" />
                  </span>{" "}
                  Search
                </Button>
                <Button color="primary" className="reset" onClick={() => handleReset(props)}>
                  <span className="right_5">
                    <img src={reset} alt="" />
                  </span>{" "}
                  Reset
                </Button>
              </Col>
            </Row>
          </div>
        );
      }}
    ></Formik>
  );
};

export default SearchFormulary;
